import { Header3, Paragraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ZalogAuctionDisclaimer.css';

export const ZalogAuctionDisclaimer = () => {
  return (
    <div className={styles['outer']}>
      <div className={styles['inner']}>
        <Header3>Реализуется через аукцион</Header3>
        <Paragraph1>
          Объект продается на открытом аукционе и&nbsp;переходит к тому, кто предложит самую высокую цену
        </Paragraph1>
      </div>
    </div>
  );
};
